// // for user header

// import { useState } from "react";
// import { FaMapMarkerAlt, FaUsers, FaGift, FaCalendarAlt, FaBell, FaUser, FaChevronDown } from "react-icons/fa";

// export default function Header() {
//   const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [isBookingsOpen, setIsBookingsOpen] = useState(false);
//   const [isProfileOpen, setIsProfileOpen] = useState(false);

//   return (
//     <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//       {/* Logo */}
//       <div className="flex items-center">
//         <img  src="/upswap.png" alt="UpSwap" className="h-10 w-auto" />
//       </div>

//       {/* Center Nav */}
//       <nav className="hidden md:flex items-center space-x-6">
//         <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//           <FaMapMarkerAlt /> Current Location
//         </button>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsActivitiesOpen(true)}
//           onMouseLeave={() => setIsActivitiesOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaUsers /> Activities <FaChevronDown className="text-xs" />
//           </button>
//           {isActivitiesOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">All Activities</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Live Activities</button>
//             </div>
//           )}
//         </div>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsServicesOpen(true)}
//           onMouseLeave={() => setIsServicesOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaGift /> Services <FaChevronDown className="text-xs" />
//           </button>
//           {isServicesOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Service 1</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Service 2</button>
//             </div>
//           )}
//         </div>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsBookingsOpen(true)}
//           onMouseLeave={() => setIsBookingsOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaCalendarAlt /> Bookings <FaChevronDown className="text-xs" />
//           </button>
//           {isBookingsOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">My Bookings</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">History</button>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Right Side: Notifications + Profile */}
//       <div className="flex items-center space-x-4">
//         <button className="relative">
//           <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//           <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//         </button>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsProfileOpen(true)}
//           onMouseLeave={() => setIsProfileOpen(false)}
//         >
//           <button className="flex items-center text-gray-700 hover:text-orange-500">
//             <FaUser className="text-xl" /> <FaChevronDown className="ml-1 text-xs" />
//           </button>
//           {isProfileOpen && (
//             <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Profile</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Logout</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// import React, { useState } from 'react';
// import { FaRegClock, FaRunning, FaStore } from 'react-icons/fa'; // Example icons, adjust as needed
// import { FiChevronDown } from 'react-icons/fi'; // For dropdown arrow

// const Navbar = () => {
//   const [activitiesOpen, setActivitiesOpen] = useState(false);

//   return (
//     <nav className="bg-white shadow-md p-4">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo */}
//         <div className="flex-shrink-0">
//           {/* Replace with your actual logo image */}
//           <img src="/upswap.png" alt="Upswap Logo" className="h-10" />
//           {/* If your logo is text: */}
//           {/* <span className="text-2xl font-bold text-orange-600">Upswap</span> */}
//         </div>

//         {/* Navigation Links (Desktop) */}
//         <div className="hidden md:flex items-center space-x-8">
//           <a href="#" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200">
//             <FaRegClock className="mr-2" /> Deals
//           </a>

//           <div className="relative">
//             <button
//               className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none"
//               onClick={() => setActivitiesOpen(!activitiesOpen)}
//             >
//               <FaRunning className="mr-2" /> Activities <FiChevronDown className={`ml-1 transition-transform duration-200 ${activitiesOpen ? 'rotate-180' : ''}`} />
//             </button>
//             {activitiesOpen && (
//               <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
//                 <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">All Activities</a>
//                 <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Live Activities</a>
//                 <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Scheduled Activities</a>
//                 {/* Add more activity links as needed */}
//               </div>
//             )}
//           </div>

//           <a href="#" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200">
//             <FaStore className="mr-2" /> Vendors
//           </a>
//         </div>

//         {/* Auth Buttons */}
//         <div className="flex items-center space-x-4">
//           <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-6 rounded-md transition-colors duration-200">
//             Sign-up
//           </button>
//           <button className="border border-gray-300 text-gray-700 hover:bg-gray-100 font-semibold py-2 px-6 rounded-md transition-colors duration-200">
//             Login
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;

// // src/components/Dashboard/PublicHeader.jsx
// import React, { useState } from 'react';
// import { FaRegClock, FaRunning, FaStore } from 'react-icons/fa';
// import { FiChevronDown } from 'react-icons/fi';
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// // Corrected import path for useAuth
// // PublicHeader.jsx is in src/components/Dashboard/
// // AuthContext.js is in src/components/authentication/
// import { useAuth } from '../Authentication/AuthContext';

// const PublicHeader = () => {
//     const [activitiesOpen, setActivitiesOpen] = useState(false);
//     const navigate = useNavigate();
//     const { login } = useAuth(); // While 'login' isn't directly called here, it's good practice
//                                 // to include it if you foresee a public header having login actions.

//     const handleLoginClick = () => {
//         navigate('/login'); // Redirect to your login page
//     };

//     const handleSignupClick = () => {
//         navigate('/Register'); // Assuming your signup page is at /Register
//     };

//     return (
//         <nav className="bg-white shadow-md p-4">
//             <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//                 {/* Logo */}
//                 <div className="flex-shrink-0">
//                     <img src="/upswap.png" alt="Upswap Logo" className="h-10" />
//                 </div>

//                 {/* Navigation Links (Desktop) */}
//                 <div className="hidden md:flex items-center space-x-8">
//                     <a href="/deals" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200">
//                         <FaRegClock className="mr-2" /> Deals
//                     </a>

//                     <div className="relative">
//                         <button
//                             className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none"
//                             onClick={() => setActivitiesOpen(!activitiesOpen)}
//                         >
//                             <FaRunning className="mr-2" /> Activities <FiChevronDown className={`ml-1 transition-transform duration-200 ${activitiesOpen ? 'rotate-180' : ''}`} />
//                         </button>
//                         {activitiesOpen && (
//                             <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
//                                 <a href="/activities/all" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">All Activities</a>
//                                 <a href="/activities/live" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Live Activities</a>
//                                 <a href="/activities/scheduled" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Scheduled Activities</a>
//                             </div>
//                         )}
//                     </div>

//                     <a href="/vendors" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200">
//                         <FaStore className="mr-2" /> Vendors
//                     </a>
//                 </div>

//                 {/* Auth Buttons */}
//                 <div className="flex items-center space-x-4">
//                     <button
//                         className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-6 rounded-md transition-colors duration-200"
//                         onClick={handleSignupClick}
//                     >
//                         Sign-up
//                     </button>
//                     <button
//                         className="border border-gray-300 text-gray-700 hover:bg-gray-100 font-semibold py-2 px-6 rounded-md transition-colors duration-200"
//                         onClick={handleLoginClick}
//                     >
//                         Login
//                     </button>
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default PublicHeader;

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaMapMarkerAlt } from "react-icons/fa";
// // import logo from "../upswap.png"; // Update the path as per your structure

// const PublicHeader = () => {
//   const navigate = useNavigate();

//   return (
//     <header className="bg-white shadow-sm py-4 px-6">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo */}
//         <div className="flex items-center space-x-4">
//           {/* <img src={logo} alt="Upswap Logo" className="h-10" /> */}

//           {/* Location */}
//           <div className="hidden md:flex items-start space-x-1 text-sm text-gray-700">
//             <FaMapMarkerAlt className="mt-1 text-gray-500" />
//             <div>
//               <div className="font-semibold">Downtown</div>
//               <div className="text-xs text-gray-500">San Francisco, California</div>
//             </div>
//           </div>
//         </div>

//         {/* Navigation */}
//         <nav className="hidden md:flex space-x-6 text-sm font-medium text-gray-700">
//           <button onClick={() => navigate("/activities")} className="hover:text-orange-500 transition">
//             Browse Activities
//           </button>
//           <button onClick={() => navigate("/deals")} className="hover:text-orange-500 transition">
//             Explore Deals
//           </button>
//           <button onClick={() => navigate("/vendors")} className="hover:text-orange-500 transition">
//             Find Vendors
//           </button>
//         </nav>

//         {/* Auth Buttons */}
//         <div className="flex space-x-4">
//           <button
//             onClick={() => navigate("/signup")}
//             className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
//           >
//             Sign Up
//           </button>
//           <button
//             onClick={() => navigate("/login")}
//             className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
//           >
//             Login
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default PublicHeader;











// // src/components/Dashboard/UserHeader.jsx (only the relevant part for clarity)
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { FaMapMarkerAlt } from "react-icons/fa";

// const PublicHeader = () => {
//   const navigate = useNavigate();

//   return (
//     <header className="bg-white shadow-sm py-4 px-6">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo and Location Group */}
//         <div className="flex items-center space-x-6 cursor-pointer">
//           {/* Logo */}
//           {/* <img src="/upswap.png" alt="UpSway Logo" className="h-10" /> */}

//           <img
//             src="/upswap.png"
//             alt="UpSway Logo"
//             className="h-10"
//             onClick={() => (window.location.href = "/home")}
//           />

//           <div className="flex items-center">
//             <FaMapMarkerAlt className="text-gray-500 text-base flex-shrink-0" />
//             <div className="flex flex-col">
//               <div className="font-semibold leading-none">Downtown</div>
//               <div className="text-xs text-gray-500 leading-none">
//                 San Francisco, California
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ... rest of your header code (Navigation and Auth Buttons) ... */}
//         <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700 gap-4">
//           {/* Location Block */}

//           {/* Navigation Buttons */}
//           <button
//             onClick={() => navigate("/LocalActivities")}
//             className="hover:text-orange-500 transition"
//           >
//             Browse Activities
//           </button>
//           <button
//             onClick={() => navigate("/ExclusiveDeals")}
//             className="hover:text-orange-500 transition"
//           >
//             Explore Deals
//           </button>
//           <button
//             onClick={() => navigate("/vendor")}
//             className="hover:text-orange-500 transition"
//           >
//             Find Vendors
//           </button>
//         </nav>

//         <div className="flex space-x-4">
//           <button
//             onClick={() => navigate("/Register")}
//             className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
//           >
//             Sign Up
//           </button>
//           <button
//             onClick={() => navigate("/login")}
//             className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
//           >
//             Login
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default PublicHeader;




// // src/components/Dashboard/UserHeader.jsx
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { toast } from "react-toastify"; // Assuming you have react-toastify setup for notifications

// const GOOGLE_MAPS_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I"; // Use the same API key as in PostActivity.jsx

// const PublicHeader = () => {
//   const navigate = useNavigate();

//   // State to manage modal visibility
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   // State to store the user's selected/entered location
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "Downtown",
//     state: "San Francisco, California",
//     latitude: null,
//     longitude: null,
//   });
//   // State for the manual input field in the modal
//   const [manualLocationInput, setManualLocationInput] = useState("");
//   // State to track if Google Maps API is loaded
//   const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
//   // Ref for the manual location input, though not strictly needed for this part,
//   // it's good practice for consistency if we were to add autocomplete here later.
//   const locationInputModalRef = useRef(null);


//   // Define the initMap callback function using useCallback
//   // This is called when the Google Maps script finishes loading.
//   const initMap = useCallback(() => {
//     setIsGoogleMapsLoaded(true);
//   }, []);

//   // Load Google Maps API script dynamically and ensure it's loaded only once
//   useEffect(() => {
//     // Check if the script is already loaded
//     if (window.google && window.google.maps && window.google.maps.places) {
//       setIsGoogleMapsLoaded(true);
//       return;
//     }

//     // Assign the initMap function to the global window object BEFORE appending the script
//     // This is crucial for the Google Maps API's callback to work.
//     window.initMap = initMap;

//     // Check if a script with the Google Maps API source already exists
//     const existingScript = document.querySelector(
//       `script[src*="maps.googleapis.com/maps/api/js"]`
//     );

//     if (existingScript) {
//       // If it exists, but isn't loaded, wait for it to load
//       existingScript.onload = () => setIsGoogleMapsLoaded(true);
//       existingScript.onerror = () =>
//         toast.error("Failed to load Google Maps API.");
//       return;
//     }

//     // If not, create and append the script
//     const script = document.createElement("script");
//     // We request 'places' and 'geocoding' libraries for robustness,
//     // although 'geocoding' functionality is available through Geocoder service
//     // which is part of the core Maps API. 'places' is generally useful for autocomplete.
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     script.id = "google-maps-script-header"; // Unique ID for this script

//     script.onerror = () => {
//       toast.error("Failed to load Google Maps API for location services.");
//     };

//     document.head.appendChild(script);

//     return () => {
//       // Clean up the global callback when the component unmounts
//       if (window.initMap === initMap) {
//         delete window.initMap;
//       }
//     };
//   }, [initMap]); // Depend on initMap (which is stable due to useCallback)


//   // Effect to load location from local storage on component mount
//   useEffect(() => {
//     const storedLocation = localStorage.getItem("userLocation");
//     if (storedLocation) {
//       setCurrentLocation(JSON.parse(storedLocation));
//     }
//   }, []);

//   // Function to handle opening the location modal
//   const handleLocationClick = () => {
//     setShowLocationModal(true);
//     setManualLocationInput(""); // Clear manual input when opening modal
//   };

//   // Function to handle closing the location modal
//   const handleCloseModal = () => {
//     setShowLocationModal(false);
//   };

//   // Function to get address details from coordinates using Google Geocoding API
//   const getAddressFromCoordinates = async (latitude, longitude) => {
//     if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
//       toast.error("Google Maps API not fully loaded. Please try again.");
//       return null;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     const latlng = { lat: latitude, lng: longitude };

//     try {
//       const { results } = await geocoder.geocode({ location: latlng });

//       if (results && results.length > 0) {
//         // Find city (locality) and state (administrative_area_level_1)
//         let city = "Unknown City";
//         let state = "Unknown Region";
//         let country = "Unknown Country"; // Added country for better fallback

//         const addressComponents = results[0].address_components;
//         addressComponents.forEach(component => {
//           if (component.types.includes("locality")) {
//             city = component.long_name;
//           } else if (component.types.includes("administrative_area_level_1")) {
//             state = component.long_name;
//           } else if (component.types.includes("country")) {
//             country = component.long_name;
//           }
//         });

//         // Fallback for state if not found, use country
//         const displayState = state !== "Unknown Region" ? state : country;

//         return {
//           city: city,
//           state: displayState,
//           latitude,
//           longitude,
//         };
//       } else {
//         toast.warn("Could not find address details for your location.");
//         return {
//           city: "Location Found",
//           state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
//           latitude,
//           longitude,
//         };
//       }
//     } catch (error) {
//       console.error("Error reverse geocoding with Google Maps:", error);
//       toast.error("Failed to fetch address details. Check console for more info.");
//       return null;
//     }
//   };


//   // Function to get current geolocation and then reverse geocode it
//   const handleUseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       toast.error("Geolocation is not supported by your browser.");
//       return;
//     }
//     if (!isGoogleMapsLoaded) {
//       toast.info("Loading location services... please try again shortly.");
//       return;
//     }

//     toast.info("Fetching your current location...");

//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         const locationDetails = await getAddressFromCoordinates(latitude, longitude);

//         if (locationDetails) {
//           setCurrentLocation(locationDetails);
//           localStorage.setItem("userLocation", JSON.stringify(locationDetails));
//           toast.success("Location updated successfully!");
//         } else {
//             // Fallback if getAddressFromCoordinates returns null
//             setCurrentLocation({
//                 city: "Unknown Address",
//                 state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
//                 latitude,
//                 longitude,
//             });
//             localStorage.setItem("userLocation", JSON.stringify({
//                 city: "Unknown Address",
//                 state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//                 latitude,
//                 longitude,
//             }));
//         }
//         setShowLocationModal(false); // Close modal after fetching
//       },
//       (error) => {
//         let errorMessage = "Unable to retrieve your location.";
//         if (error.code === error.PERMISSION_DENIED) {
//           errorMessage = "Location access denied. Please allow location services in your browser settings.";
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           errorMessage = "Location information is unavailable.";
//         } else if (error.code === error.TIMEOUT) {
//           errorMessage = "The request to get location timed out.";
//         }
//         console.error("Geolocation error:", error);
//         toast.error(errorMessage);
//       }
//     );
//   };

//   // Function to handle manual location submission
//   const handleManualLocationSubmit = () => {
//     if (manualLocationInput.trim() === "") {
//       toast.warn("Please enter a location.");
//       return;
//     }
    
//     const parts = manualLocationInput.split(',').map(p => p.trim());
//     const city = parts[0] || manualLocationInput.trim();
//     // If there's a second part (e.g., "New Delhi, India"), use it as state. Otherwise, use an empty string.
//     const state = parts.length > 1 ? parts.slice(1).join(', ') : "";

//     setCurrentLocation({
//       city: city,
//       state: state, // No longer "Manually entered"
//       latitude: null,
//       longitude: null,
//     });
//     localStorage.setItem(
//       "userLocation",
//       JSON.stringify({
//         city: city,
//         state: state, // No longer "Manually entered"
//         latitude: null,
//         longitude: null,
//       })
//     );
//     setShowLocationModal(false); // Close modal after submission
//     toast.success("Manual location set successfully!");
//   };

//   return (
//     <header className="bg-white shadow-sm py-4 px-6">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo and Location Group */}
//         <div className="flex items-center space-x-6">
//           {/* Logo */}
//           <img
//             src="/upswap.png"
//             alt="UpSway Logo"
//             className="h-10 cursor-pointer"
//             onClick={() => (window.location.href = "/home")}
//           />

//           {/* Location Display - Made clickable */}
//           <div
//             className="flex items-center cursor-pointer"
//             onClick={handleLocationClick}
//           >
//             <FaMapMarkerAlt className="text-gray-500 text-base flex-shrink-0" />
//             <div className="flex flex-col">
//               <div className="font-semibold leading-none">
//                 {currentLocation.city}
//               </div>
//               <div className="text-xs text-gray-500 leading-none">
//                 {currentLocation.state}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Navigation and Auth Buttons */}
//         <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700 gap-4">
//           <button
//             onClick={() => navigate("/LocalActivities")}
//             className="hover:text-orange-500 transition"
//           >
//             Browse Activities
//           </button>
//           <button
//             onClick={() => navigate("/PopularDeals")}
//             className="hover:text-orange-500 transition"
//           >
//             Explore Deals
//           </button>
//           <button
//             onClick={() => navigate("/vendor")}
//             className="hover:text-orange-500 transition"
//           >
//             Find Vendors
//           </button>
//         </nav>

//         <div className="flex space-x-4">
//           <button
//             onClick={() => navigate("/Register")}
//             className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
//           >
//             Sign Up
//           </button>
//           <button
//             onClick={() => navigate("/login")}
//             className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
//           >
//             Login
//           </button>
//         </div>
//       </div>

//       {/* Location Selection Modal */}
//       {showLocationModal && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-xl w-96">
//             <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

//             {/* Use Current Location Button */}
//             <button
//               onClick={handleUseCurrentLocation}
//               disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
//               className={`w-full py-2 px-4 rounded-md transition mb-4 ${
//                 !isGoogleMapsLoaded
//                   ? "bg-blue-300 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               <FaMapMarkerAlt className="inline-block mr-2" />
//               {isGoogleMapsLoaded ? "Use My Current Location" : "Loading Location Services..."}
//             </button>

//             <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

//             {/* Manual Location Input */}
//             <input
//               type="text"
//               ref={locationInputModalRef} // Assign ref here if you want to use Google Places Autocomplete on this input later
//               placeholder="Enter location manually (e.g., New Delhi, India)"
//               className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
//               value={manualLocationInput}
//               onChange={(e) => setManualLocationInput(e.target.value)}
//             />
//             <button
//               onClick={handleManualLocationSubmit}
//               className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
//             >
//               Set Location
//             </button>

//             {/* Close Button */}
//             <button
//               onClick={handleCloseModal}
//               className="w-full border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-100 transition"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default PublicHeader;









// src/components/Dashboard/UserHeader.jsx
// src/components/Dashboard/UserHeader.jsx











// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaMapMarkerAlt, FaTimes } from "react-icons/fa"; // Imported FaTimes icon
// import { toast } from "react-toastify"; // Assuming you have react-toastify setup for notifications

// const Maps_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I"; // Use the same API key as in PostActivity.jsx

// const PublicHeader = () => {
//   const navigate = useNavigate();

//   // State to manage modal visibility
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   // State to store the user's selected/entered location
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "Downtown",
//     state: "San Francisco, California",
//     latitude: null,
//     longitude: null,
//   });
//   // State for the manual input field in the modal
//   const [manualLocationInput, setManualLocationInput] = useState("");
//   // State to track if Google Maps API is loaded
//   const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
//   // Ref for the manual location input field in the modal to attach autocomplete
//   const locationInputModalRef = useRef(null);

//   // Variable to hold the Google Places Autocomplete instance
//   const autocompleteInstance = useRef(null);

//   // Define the initMap callback function using useCallback
//   // This is called when the Google Maps script finishes loading.
//   const initMap = useCallback(() => {
//     setIsGoogleMapsLoaded(true);
//   }, []);

//   // Load Google Maps API script dynamically and ensure it's loaded only once
//   useEffect(() => {
//     // Check if the script is already loaded
//     if (window.google && window.google.maps && window.google.maps.places) {
//       setIsGoogleMapsLoaded(true);
//       return;
//     }

//     // Assign the initMap function to the global window object BEFORE appending the script
//     // This is crucial for the Google Maps API's callback to work.
//     window.initMap = initMap;

//     // Check if a script with the Google Maps API source already exists
//     const existingScript = document.querySelector(
//       `script[src*="maps.googleapis.com/maps/api/js"]`
//     );

//     if (existingScript) {
//       // If it exists, but isn't loaded, wait for it to load
//       existingScript.onload = () => setIsGoogleMapsLoaded(true);
//       existingScript.onerror = () =>
//         toast.error("Failed to load Google Maps API.");
//       return;
//     }

//     // If not, create and append the script
//     const script = document.createElement("script");
//     // We request 'places' and 'geocoding' libraries. 'places' is essential for Autocomplete.
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${Maps_API_KEY}&libraries=places&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     script.id = "google-maps-script-header"; // Unique ID for this script

//     script.onerror = () => {
//       toast.error("Failed to load Google Maps API for location services.");
//     };

//     document.head.appendChild(script);

//     return () => {
//       // Clean up the global callback when the component unmounts
//       if (window.initMap === initMap) {
//         delete window.initMap;
//       }
//     };
//   }, [initMap]); // Depend on initMap (which is stable due to useCallback)

//   // Initialize Google Places Autocomplete when modal is open and API is loaded
//   useEffect(() => {
//     if (isGoogleMapsLoaded && showLocationModal && locationInputModalRef.current) {
//       // Ensure Autocomplete is only initialized once for this input
//       if (!autocompleteInstance.current) {
//         try {
//           autocompleteInstance.current = new window.google.maps.places.Autocomplete(
//             locationInputModalRef.current,
//             {
//               types: ['(cities)'], // Restrict results to cities (or 'geocode' for broader addresses)
//               componentRestrictions: { country: ['in'] }, // Restrict to India
//             }
//           );

//           autocompleteInstance.current.addListener("place_changed", () => {
//             const place = autocompleteInstance.current.getPlace();

//             if (place.geometry && place.formatted_address) {
//               let city = "Unknown City";
//               let state = ""; // Default to empty for state/country
//               let latitude = place.geometry.location.lat();
//               let longitude = place.geometry.location.lng();

//               // Extract city and state/country from address_components
//               const addressComponents = place.address_components;
//               addressComponents.forEach(component => {
//                 if (component.types.includes("locality")) {
//                   city = component.long_name;
//                 } else if (component.types.includes("administrative_area_level_1")) {
//                   state = component.long_name;
//                 } else if (component.types.includes("country")) {
//                   // If state is not found, use country as fallback for 'state' field
//                   if (!state) {
//                     state = component.long_name;
//                   }
//                 }
//               });

//               setCurrentLocation({
//                 city: city,
//                 state: state,
//                 latitude: latitude,
//                 longitude: longitude,
//               });
//               localStorage.setItem("userLocation", JSON.stringify({
//                 city: city,
//                 state: state,
//                 latitude: latitude,
//                 longitude: longitude,
//               }));
//               setManualLocationInput(place.formatted_address); // Update input field with selected place's full address
//               setShowLocationModal(false); // Close modal
//               toast.success("Location updated!");
//             } else {
//               toast.warn("No details available for the selected location.");
//               // If no geometry/formatted address, fall back to current input value
//               handleManualLocationSubmit(true); // Treat as manual submission
//             }
//           });
//         } catch (error) {
//           console.error("Error initializing Google Autocomplete:", error);
//           toast.error("Failed to initialize location suggestions. Please try manual entry.");
//         }
//       }
//     }

//     // Cleanup: Remove listener and destroy autocomplete instance when modal closes or component unmounts
//     return () => {
//       if (autocompleteInstance.current) {
//         if (window.google && window.google.maps && window.google.maps.event) {
//           window.google.maps.event.clearInstanceListeners(autocompleteInstance.current);
//         }
//         autocompleteInstance.current = null;
//       }
//     };
//   }, [isGoogleMapsLoaded, showLocationModal]); // Re-run when API loads or modal state changes


//   // Effect to load location from local storage on component mount
//   useEffect(() => {
//     const storedLocation = localStorage.getItem("userLocation");
//     if (storedLocation) {
//       setCurrentLocation(JSON.parse(storedLocation));
//     }
//   }, []);

//   // New useEffect to handle body overflow when modal is open/closed
//   useEffect(() => {
//     if (showLocationModal) {
//       document.body.style.overflow = 'hidden'; // Prevent scrolling
//     } else {
//       document.body.style.overflow = ''; // Allow scrolling
//     }
//     // Cleanup function to ensure overflow is reset if component unmounts while modal is open
//     return () => {
//       document.body.style.overflow = '';
//     };
//   }, [showLocationModal]); // Re-run effect whenever showLocationModal changes


//   // Function to handle opening the location modal
//   const handleLocationClick = () => {
//     setShowLocationModal(true);
//     setManualLocationInput(""); // Clear manual input when opening modal
//   };

//   // Function to handle closing the location modal
//   const handleCloseModal = () => {
//     setShowLocationModal(false);
//   };

//   // Function to get address details from coordinates using Google Geocoding API
//   const getAddressFromCoordinates = async (latitude, longitude) => {
//     if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
//       toast.error("Google Maps API not fully loaded. Please try again.");
//       return null;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     const latlng = { lat: latitude, lng: longitude };

//     try {
//       const { results } = await geocoder.geocode({ location: latlng });

//       if (results && results.length > 0) {
//         let city = "Unknown City";
//         let state = "Unknown Region";
//         let country = "Unknown Country";

//         const addressComponents = results[0].address_components;
//         addressComponents.forEach(component => {
//           if (component.types.includes("locality")) {
//             city = component.long_name;
//           } else if (component.types.includes("administrative_area_level_1")) {
//             state = component.long_name;
//           } else if (component.types.includes("country")) {
//             country = component.long_name;
//           }
//         });

//         const displayState = state !== "Unknown Region" ? state : country;

//         return {
//           city: city,
//           state: displayState,
//           latitude,
//           longitude,
//         };
//       } else {
//         toast.warn("Could not find address details for your current location.");
//         return {
//           city: "Location Found",
//           state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
//           latitude,
//           longitude,
//         };
//       }
//     } catch (error) {
//       console.error("Error reverse geocoding with Google Maps:", error);
//       toast.error("Failed to fetch address details. Check console for more info.");
//       return null;
//     }
//   };


//   // Function to get current geolocation and then reverse geocode it
//   const handleUseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       toast.error("Geolocation is not supported by your browser.");
//       return;
//     }
//     if (!isGoogleMapsLoaded) {
//       toast.info("Loading location services... please try again shortly.");
//       return;
//     }

//     toast.info("Fetching your current location...");

//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         const locationDetails = await getAddressFromCoordinates(latitude, longitude);

//         if (locationDetails) {
//           setCurrentLocation(locationDetails);
//           localStorage.setItem("userLocation", JSON.stringify(locationDetails));
//           toast.success("Location updated successfully!");
//         } else {
//             // Fallback if getAddressFromCoordinates returns null
//             setCurrentLocation({
//                 city: "Unknown Address",
//                 state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//                 latitude,
//                 longitude,
//             });
//             localStorage.setItem("userLocation", JSON.stringify({
//                 city: "Unknown Address",
//                 state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//                 latitude,
//                 longitude,
//             }));
//         }
//         setShowLocationModal(false); // Close modal after fetching
//       },
//       (error) => {
//         let errorMessage = "Unable to retrieve your location.";
//         if (error.code === error.PERMISSION_DENIED) {
//           errorMessage = "Location access denied. Please allow location services in your browser settings.";
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           errorMessage = "Location information is unavailable.";
//         } else if (error.code === error.TIMEOUT) {
//           errorMessage = "The request to get location timed out.";
//         }
//         console.error("Geolocation error:", error);
//         toast.error(errorMessage);
//       }
//     );
//   };

//   // Function to handle manual location submission
//   // Added optional parameter to differentiate if called internally (e.g., from autocomplete fallback)
//   const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
//     if (manualLocationInput.trim() === "") {
//       if (!fromAutocompleteFallback) { // Only warn if not a fallback from autocomplete
//         toast.warn("Please enter a location.");
//       }
//       return;
//     }
    
//     const parts = manualLocationInput.split(',').map(p => p.trim());
//     const city = parts[0] || manualLocationInput.trim();
//     const state = parts.length > 1 ? parts.slice(1).join(', ') : "";

//     setCurrentLocation({
//       city: city,
//       state: state,
//       latitude: null, // No lat/lng for simple manual entry without geocoding
//       longitude: null, // No lat/lng for simple manual entry without geocoding
//     });
//     localStorage.setItem(
//       "userLocation",
//       JSON.stringify({
//         city: city,
//         state: state,
//         latitude: null,
//         longitude: null,
//       })
//     );
//     setShowLocationModal(false); // Close modal after submission
//     if (!fromAutocompleteFallback) { // Only show success toast if not a fallback
//         toast.success("Manual location set successfully!");
//     }
//   };

//   return (
//     <header className="bg-white shadow-sm py-4 px-6">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo and Location Group */}
//         <div className="flex items-center space-x-6">
//           {/* Logo */}
//           <img
//             src="/upswap.png"
//             alt="UpSway Logo"
//             className="h-10 cursor-pointer"
//             onClick={() => (window.location.href = "/home")}
//           />

//           {/* Location Display - Made clickable */}
//           <div
//             className="flex items-center cursor-pointer"
//             onClick={handleLocationClick}
//           >
//             <FaMapMarkerAlt className="text-gray-500 text-base flex-shrink-0" />
//             <div className="flex flex-col">
//               <div className="font-semibold leading-none">
//                 {currentLocation.city}
//               </div>
//               <div className="text-xs text-gray-500 leading-none">
//                 {currentLocation.state}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Navigation and Auth Buttons */}
//         <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700 gap-4">
//           <button
//             onClick={() => navigate("/LocalActivities")}
//             className="hover:text-orange-500 transition"
//           >
//             Browse Activities
//           </button>
//           <button
//             onClick={() => navigate("/PopularDeals")}
//             className="hover:text-orange-500 transition"
//           >
//             Explore Deals
//           </button>
//           <button
//             onClick={() => navigate("/vendor")}
//             className="hover:text-orange-500 transition"
//           >
//             Find Vendors
//           </button>
//         </nav>

//         <div className="flex space-x-4">
//           <button
//             onClick={() => navigate("/Register")}
//             className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
//           >
//             Sign Up
//           </button>
//           <button
//             onClick={() => navigate("/login")}
//             className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
//           >
//             Login
//           </button>
//         </div>
//       </div>

//       {/* Location Selection Modal */}
//       {showLocationModal && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
//           <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8">
//             {/* Close Icon in top-right corner */}
//             <button
//               onClick={handleCloseModal}
//               className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
//               aria-label="Close location selection"
//             >
//               <FaTimes size={20} />
//             </button>

//             <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

//             {/* Use Current Location Button */}
//             <button
//               onClick={handleUseCurrentLocation}
//               disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
//               className={`w-full py-2 px-4 rounded-md transition mb-4 ${
//                 !isGoogleMapsLoaded
//                   ? "bg-blue-300 cursor-not-allowed"
//                   : "bg-blue-500 text-white hover:bg-blue-600"
//               }`}
//             >
//               <FaMapMarkerAlt className="inline-block mr-2" />
//               {isGoogleMapsLoaded ? "Use My Current Location" : "Loading Location Services..."}
//             </button>

//             <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

//             {/* Manual Location Input with Autocomplete */}
//             <input
//               type="text"
//               ref={locationInputModalRef} // Assign ref to this input
//               placeholder="Enter location manually (e.g., New Delhi, India)"
//               className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
//               value={manualLocationInput}
//               onChange={(e) => setManualLocationInput(e.target.value)}
//             />
//             {/* The Set Location button is now primarily for when the user types and doesn't select a suggestion */}
//             <button
//               onClick={() => handleManualLocationSubmit()} // Call without fallback flag
//               className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
//             >
//               Set Location
//             </button>
//             {/* Removed the old Close Button here */}
//           </div>
//         </div>
//       )}
//     </header>
//   );
// };

// export default PublicHeader;













import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa"; // Imported FaTimes icon
import { toast } from "react-toastify"; // Assuming you have react-toastify setup for notifications

const Maps_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I"; // Use the same API key as in PostActivity.jsx

const PublicHeader = () => {
  const navigate = useNavigate();

  // State to manage modal visibility
  const [showLocationModal, setShowLocationModal] = useState(false);
  // State to store the user's selected/entered location
  const [currentLocation, setCurrentLocation] = useState({
    city: "Downtown",
    state: "San Francisco, California",
    latitude: null,
    longitude: null,
  });
  // State for the manual input field in the modal
  const [manualLocationInput, setManualLocationInput] = useState("");
  // State to track if Google Maps API is loaded
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
  // Ref for the manual location input field in the modal to attach autocomplete
  const locationInputModalRef = useRef(null);

  // Variable to hold the Google Places Autocomplete instance
  const autocompleteInstance = useRef(null);

  // Define the initMap callback function using useCallback
  // This is called when the Google Maps script finishes loading.
  const initMap = useCallback(() => {
    setIsGoogleMapsLoaded(true);
  }, []);

  // Load Google Maps API script dynamically and ensure it's loaded only once
  useEffect(() => {
    // Check if the script is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      setIsGoogleMapsLoaded(true);
      return;
    }

    // Assign the initMap function to the global window object BEFORE appending the script
    // This is crucial for the Google Maps API's callback to work.
    window.initMap = initMap;

    // Check if a script with the Google Maps API source already exists
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );

    if (existingScript) {
      // If it exists, but isn't loaded, wait for it to load
      existingScript.onload = () => setIsGoogleMapsLoaded(true);
      existingScript.onerror = () =>
        toast.error("Failed to load Google Maps API.");
      return;
    }

    // If not, create and append the script
    const script = document.createElement("script");
    // We request 'places' and 'geocoding' libraries. 'places' is essential for Autocomplete.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${Maps_API_KEY}&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    script.id = "google-maps-script-header"; // Unique ID for this script

    script.onerror = () => {
      toast.error("Failed to load Google Maps API for location services.");
    };

    document.head.appendChild(script);

    return () => {
      // Clean up the global callback when the component unmounts
      if (window.initMap === initMap) {
        delete window.initMap;
      }
    };
  }, [initMap]); // Depend on initMap (which is stable due to useCallback)

  // Initialize Google Places Autocomplete when modal is open and API is loaded
  useEffect(() => {
    if (isGoogleMapsLoaded && showLocationModal && locationInputModalRef.current) {
      // Ensure Autocomplete is only initialized once for this input
      if (!autocompleteInstance.current) {
        try {
          autocompleteInstance.current = new window.google.maps.places.Autocomplete(
            locationInputModalRef.current,
            {
              types: ['(cities)'], // Restrict results to cities (or 'geocode' for broader addresses)
              // REMOVED: componentRestrictions: { country: ['in'] }, // This line was restricting to India
            }
          );

          autocompleteInstance.current.addListener("place_changed", () => {
            const place = autocompleteInstance.current.getPlace();

            if (place.geometry && place.formatted_address) {
              let city = "Unknown City";
              let state = ""; // Default to empty for state/country
              let latitude = place.geometry.location.lat();
              let longitude = place.geometry.location.lng();

              // Extract city and state/country from address_components
              const addressComponents = place.address_components;
              addressComponents.forEach(component => {
                if (component.types.includes("locality")) {
                  city = component.long_name;
                } else if (component.types.includes("administrative_area_level_1")) {
                  state = component.long_name;
                } else if (component.types.includes("country")) {
                  // If state is not found, use country as fallback for 'state' field
                  if (!state) {
                    state = component.long_name;
                  }
                }
              });

              setCurrentLocation({
                city: city,
                state: state,
                latitude: latitude,
                longitude: longitude,
              });
              localStorage.setItem("userLocation", JSON.stringify({
                city: city,
                state: state,
                latitude: latitude,
                longitude: longitude,
              }));
              setManualLocationInput(place.formatted_address); // Update input field with selected place's full address
              setShowLocationModal(false); // Close modal
              toast.success("Location updated!");
            } else {
              toast.warn("No details available for the selected location.");
              // If no geometry/formatted address, fall back to current input value
              handleManualLocationSubmit(true); // Treat as manual submission
            }
          });
        } catch (error) {
          console.error("Error initializing Google Autocomplete:", error);
          toast.error("Failed to initialize location suggestions. Please try manual entry.");
        }
      }
    }

    // Cleanup: Remove listener and destroy autocomplete instance when modal closes or component unmounts
    return () => {
      if (autocompleteInstance.current) {
        if (window.google && window.google.maps && window.google.maps.event) {
          window.google.maps.event.clearInstanceListeners(autocompleteInstance.current);
        }
        autocompleteInstance.current = null;
      }
    };
  }, [isGoogleMapsLoaded, showLocationModal]); // Re-run when API loads or modal state changes


  // Effect to load location from local storage on component mount
  useEffect(() => {
    const storedLocation = localStorage.getItem("userLocation");
    if (storedLocation) {
      setCurrentLocation(JSON.parse(storedLocation));
    }
  }, []);

  // New useEffect to handle body overflow when modal is open/closed
  useEffect(() => {
    if (showLocationModal) {
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    } else {
      document.body.style.overflow = ''; // Allow scrolling
    }
    // Cleanup function to ensure overflow is reset if component unmounts while modal is open
    return () => {
      document.body.style.overflow = '';
    };
  }, [showLocationModal]); // Re-run effect whenever showLocationModal changes


  // Function to handle opening the location modal
  const handleLocationClick = () => {
    setShowLocationModal(true);
    setManualLocationInput(""); // Clear manual input when opening modal
  };

  // Function to handle closing the location modal
  const handleCloseModal = () => {
    setShowLocationModal(false);
  };

  // Function to get address details from coordinates using Google Geocoding API
  const getAddressFromCoordinates = async (latitude, longitude) => {
    if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
      toast.error("Google Maps API not fully loaded. Please try again.");
      return null;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: latitude, lng: longitude };

    try {
      const { results } = await geocoder.geocode({ location: latlng });

      if (results && results.length > 0) {
        let city = "Unknown City";
        let state = "Unknown Region";
        let country = "Unknown Country";

        const addressComponents = results[0].address_components;
        addressComponents.forEach(component => {
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          }
        });

        const displayState = state !== "Unknown Region" ? state : country;

        return {
          city: city,
          state: displayState,
          latitude,
          longitude,
        };
      } else {
        toast.warn("Could not find address details for your current location.");
        return {
          city: "Location Found",
          state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
          latitude,
          longitude,
        };
      }
    } catch (error) {
      console.error("Error reverse geocoding with Google Maps:", error);
      toast.error("Failed to fetch address details. Check console for more info.");
      return null;
    }
  };


  // Function to get current geolocation and then reverse geocode it
  const handleUseCurrentLocation = async () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser.");
      return;
    }
    if (!isGoogleMapsLoaded) {
      toast.info("Loading location services... please try again shortly.");
      return;
    }

    toast.info("Fetching your current location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const locationDetails = await getAddressFromCoordinates(latitude, longitude);

        if (locationDetails) {
          setCurrentLocation(locationDetails);
          localStorage.setItem("userLocation", JSON.stringify(locationDetails));
          toast.success("Location updated successfully!");
        } else {
            // Fallback if getAddressFromCoordinates returns null
            setCurrentLocation({
                city: "Unknown Address",
                state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
                latitude,
                longitude,
            });
            localStorage.setItem("userLocation", JSON.stringify({
                city: "Unknown Address",
                state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
                latitude,
                longitude,
            }));
        }
        setShowLocationModal(false); // Close modal after fetching
      },
      (error) => {
        let errorMessage = "Unable to retrieve your location.";
        if (error.code === error.PERMISSION_DENIED) {
          errorMessage = "Location access denied. Please allow location services in your browser settings.";
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          errorMessage = "Location information is unavailable.";
        } else if (error.code === error.TIMEOUT) {
          errorMessage = "The request to get location timed out.";
        }
        console.error("Geolocation error:", error);
        toast.error(errorMessage);
      }
    );
  };

  // Function to handle manual location submission
  // Added optional parameter to differentiate if called internally (e.g., from autocomplete fallback)
  const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
    if (manualLocationInput.trim() === "") {
      if (!fromAutocompleteFallback) { // Only warn if not a fallback from autocomplete
        toast.warn("Please enter a location.");
      }
      return;
    }
    
    const parts = manualLocationInput.split(',').map(p => p.trim());
    const city = parts[0] || manualLocationInput.trim();
    const state = parts.length > 1 ? parts.slice(1).join(', ') : "";

    setCurrentLocation({
      city: city,
      state: state,
      latitude: null, // No lat/lng for simple manual entry without geocoding
      longitude: null, // No lat/lng for simple manual entry without geocoding
    });
    localStorage.setItem(
      "userLocation",
      JSON.stringify({
        city: city,
        state: state,
        latitude: null,
        longitude: null,
      })
    );
    setShowLocationModal(false); // Close modal after submission
    if (!fromAutocompleteFallback) { // Only show success toast if not a fallback
        toast.success("Manual location set successfully!");
    }
  };

  return (
    <header className="bg-white shadow-sm py-4 px-6">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center">
        {/* Logo and Location Group */}
        <div className="flex items-center space-x-6">
          {/* Logo */}
          <img
            src="/upswap.png"
            alt="UpSway Logo"
            className="h-10 cursor-pointer"
            onClick={() => (window.location.href = "/home")}
          />

          {/* Location Display - Made clickable */}
          <div
            className="flex items-center cursor-pointer"
            onClick={handleLocationClick}
          >
            <FaMapMarkerAlt className="text-gray-500 text-base flex-shrink-0" />
            <div className="flex flex-col">
              <div className="font-semibold leading-none">
                {currentLocation.city}
              </div>
              <div className="text-xs text-gray-500 leading-none">
                {currentLocation.state}
              </div>
            </div>
          </div>
        </div>

        {/* Navigation and Auth Buttons */}
        <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700 gap-4">
          <button
            onClick={() => navigate("/LocalActivities")}
            className="hover:text-orange-500 transition"
          >
            Browse Activities
          </button>
          <button
            onClick={() => navigate("/PopularDeals")}
            className="hover:text-orange-500 transition"
          >
            Explore Deals
          </button>
          <button
            onClick={() => navigate("/vendor")}
            className="hover:text-orange-500 transition"
          >
            Find Vendors
          </button>
        </nav>

        <div className="flex space-x-4">
          <button
            onClick={() => navigate("/Register")}
            className="bg-orange-500 text-white font-semibold px-5 py-2 rounded-md hover:bg-orange-600 transition"
          >
            Sign Up
          </button>
          <button
            onClick={() => navigate("/login")}
            className="border border-gray-300 text-gray-700 font-semibold px-5 py-2 rounded-md hover:bg-gray-100 transition"
          >
            Login
          </button>
        </div>
      </div>

      {/* Location Selection Modal */}
      {showLocationModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8">
            {/* Close Icon in top-right corner */}
            <button
              onClick={handleCloseModal}
              className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
              aria-label="Close location selection"
            >
              <FaTimes size={20} />
            </button>

            <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

            {/* Use Current Location Button */}
            <button
              onClick={handleUseCurrentLocation}
              disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
              className={`w-full py-2 px-4 rounded-md transition mb-4 ${
                !isGoogleMapsLoaded
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              <FaMapMarkerAlt className="inline-block mr-2" />
              {isGoogleMapsLoaded ? "Use My Current Location" : "Loading Location Services..."}
            </button>

            <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

            {/* Manual Location Input with Autocomplete */}
            <input
              type="text"
              ref={locationInputModalRef} // Assign ref to this input
              placeholder="Enter location manually (e.g., New York, USA)"
              className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
              value={manualLocationInput}
              onChange={(e) => setManualLocationInput(e.target.value)}
            />
            {/* The Set Location button is now primarily for when the user types and doesn't select a suggestion */}
            <button
              onClick={() => handleManualLocationSubmit()} // Call without fallback flag
              className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
            >
              Set Location
            </button>
            {/* Removed the old Close Button here */}
          </div>
        </div>
      )}
    </header>
  );
};

export default PublicHeader;